import GeoContext from 'contexts/geoContext'
import React, { useContext } from 'react'
import Caption from '../Typography/Caption'

interface Props {
  taxesAndFees: number | 'inclusive' | 'exclusive'
  /**
   * overrides the same property value from the Geo state
   */
  isTaxExclusiveRegion?: boolean
}

function PriceRowTaxesAndFees(props: Props) {
  const {
    taxesAndFees,
    isTaxExclusiveRegion,
  } = props
  const geo = useContext(GeoContext)

  const isExclusive = (geo.isTaxExclusiveRegion || !!isTaxExclusiveRegion) && (taxesAndFees === 'exclusive' || (taxesAndFees !== 'inclusive' && taxesAndFees > 0))
  const shouldHighlight = !isExclusive && geo.isTaxExclusiveRegion

  return <Caption
    variant="large"
    weight="normal"
    colour={shouldHighlight ? 'highlight-secondary' : 'neutral-three'}
  >
    {isExclusive && <>Taxes & fees apply</>}
    {!isExclusive && <>Includes taxes & fees</>}
  </Caption>
}

export default PriceRowTaxesAndFees
